// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ComponentTableFragmentDoc = gql`
    fragment componentTable on ComponentTable {
  table {
    header {
      cells
    }
    body {
      rows {
        cells
      }
    }
  }
}
    `;